/*
 * The line every text ends with: the church, then how to stop.
 *
 * Carriers require both in a message a campaign sends (CTIA Messaging Principles; Twilio's 10DLC review), so the
 * database adds it at send time and no template can leave it out (supabase/migrations/20260930010000). This is the
 * same line, so the editor can count it: a 150-character template is two texts, not one, once the line is on.
 *
 * Must match private.sms_footer character for character.
 */

/** What every text says after the church's name. Plain GSM-7 text, so on its own it never forces unicode. */
export const SMS_OPT_OUT = "Reply STOP to opt out";

/** The line, with the newline that separates it from the message. */
export function smsFooter(churchName: string | null | undefined): string {
  const name = (churchName ?? "").trim();
  return `\n${name === "" ? "HoW" : name}: ${SMS_OPT_OUT}`;
}

/** The text a member receives: the message, then the line. */
export function withSmsFooter(body: string, churchName: string | null | undefined): string {
  return body + smsFooter(churchName);
}
